export function FilterIcon() {
  return (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H16V2H0V0ZM2 6H14V8H2V6ZM12 12H4V14H12V12Z"
        fill="currentColor"
      />
    </svg>
  );
}
